import React, { useState, useEffect, useRef, useMemo } from 'react';
import Filter from '@/pages/intelligence/pages/TopCharts/components/CommonFilter';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { getDefaultTime, getComputeType } from '@/pages/intelligence/utils/topchartsUtils';
import {
  getTopList,
  getMaketsType,
  getFixedTableData,
} from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/utilsTmp/countryUtils';
import { fetchMetricsDateRanges } from '@intelligence/v3/services/topCharts';
import { useIntl, getLocale, useSelector } from 'umi';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import { getPUCDigitalPyhsicalListTrendTitle } from './_util';
import { FetchParamsType } from './_type';
import { GuideCompetitorDelay as UserGuideCompetitor } from '@intelligence/components/UserGuide/Competitor';
import useEarliestTime from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/utilsTmp/useEarliestTime';
import CombineContent from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/components/StatsContext';
import {
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
  TopchartPageId,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { DETAIL_PAGEID } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_config';
import {
  getDefaultPageSortAttr,
  getIsFortyPage,
} from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_utils';
import { pcuSEGMENT } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/constant';
import { valueFormat } from '@/pages/intelligence/utils/commonUtils';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { getDbiFilterParams } from '@intelligence/utils/filterUtils';
import useChartDownloadHooks from '@/pages/intelligence/pages/TopCharts/_hooks/useChartDownloadHooks';
import { COMBINEID_REG } from '@intelligence/utils/constant';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { handleMetricExplanationTipsClick } from '@intelligence/v3/utils/topcharts';
import { pcconsoleStats } from '@intelligence/v3/constants/downloadLogPoint';
import VisuailsMetricSelector from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/components/VisuailsMetricSelector';
import { DATASOURCE_NAME } from '@intelligence/components/DataSourceComponents';
import {
  buildCountriesChartDisplayList,
  buildCountriesTableDisplayList,
  buildCountriesChartRequestParams,
  filterCountriesByMetric,
} from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_utils/countriesChartOthers';

export default function PCUPhysicalDigital(props: any) {
  const {
    isBasicLoading,
    loading,
    setLoading,
    tabType,
    pageId,
    basicInfo,
    regionsCountries,
    gameId,
    appIds,
    entityType,
    isTwoMonths,
    activeSegment,
    mainSegment,
    subSegment,
    releaseInFortyDay,
    filterCfg,
    filterLoading,
    filterIcon,
    pageCfg,
    pageParameters,
    metricKey,
    getTrendsFun,
    getMarketTrendsFun,
    getMarketTableFun,
    gsdDevicesFlatten,
    gsdSegments,
    downloadModalSize = 820,
    lineSourceName,
    filterLeftComp,
    showDropdownBtnList = true,
    combineGameIdList,
  } = props;

  const filterInstance = useRef<any>(null);

  // console.log('PCUPhysicalDigital', props);

  const DEFAULT_FORM_VALUE = filterCfg?.defaultValue || [];
  // 根据ChartContext消费者，获取对方属性
  // const { setStatsChartOption } = useContext(ChartContext);
  const topchartsState = useSelector((state: any) => state?.[DBI_TOPCHARTS] || {});
  // 在筛选器这里拿到缓存的值，并渲染
  const filterName = ''; // getFilterName(userInfo);
  const filterData = {} as any; // getFilterValueStorage(userInfo);
  const defaultByDeviceVal = pageCfg?.defaultByDeviceVal || undefined;
  const isStatsPage = tabType === 'stats';
  const isCountriesPage = tabType === 'countries';
  const isStatsOrCountries = isStatsPage || isCountriesPage;
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const marketChartTypeRef = useRef('line');
  const defaultSegmentValue = 'All';
  const [digReveSegment, setDigReveSegment] = useState<any>(defaultSegmentValue);
  const [unitsRedio, setUnitsRedio] = useState('Full Game');
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend({});
  // stats、countries 默认 us, 避免继承地址选项影响导致不能默认选中 us
  const filerExtendWithoutRegion = useMemo(
    () => ({
      ...detailFilterExtend,
      ...(isStatsOrCountries ? { region: DEFAULT_FORM_VALUE[filterKeyMap.REGION] } : {}),
    }),
    [detailFilterExtend, isStatsOrCountries, DEFAULT_FORM_VALUE],
  );

  const [filterValue, setFilterVale] = useState(
    isOperateDetail ? filerExtendWithoutRegion : DEFAULT_FORM_VALUE,
  );
  const isFortyDay = getIsFortyPage(pageId, entityType, releaseInFortyDay, gameId);
  const isFortyDayTimeType = !isOperateDetail && isFortyDay;
  const [fetchParams, setFetchParams] = useState<FetchParamsType>({
    ...pageParameters, // 这里是自定义参数
    date_type: isFortyDayTimeType ? 'daily' : pageParameters?.date_type,
  });
  const [pieData, setPieData] = useState<any[]>([]);
  const [deviceLineData, setDeviceLineData] = useState<any[]>([]);
  const [deviceBarData, setDeviceBarData] = useState<any[]>([]);
  const [devicePieData, setDevicePieData] = useState<any[]>([]);
  const [trendLineList, setTrendLineList] = useState<any>([]);
  const [trendTableList, setTrendTableList] = useState<any>([]);
  const [trendChartType, setTrendChartType] = useState<string>('line');
  const [marketLineList, setMarketLineList] = useState<any>([]);
  const [marketTableList, setMarketTableList] = useState<any>([]);
  const [marketChartTop5List, setMarketChartTop5List] = useState<any>([]);
  const [marketPieOtherList, setMarketPieOtherList] = useState<any>([]); // 饼图额外 Others 数据
  const [topListTmpCur, setTopListTmpCur] = useState<any>([]);
  const [countryDeviceList, setCountryDeviceList] = useState<any>([]);
  const [trendLoading, setTrendLoading] = useState(loading);
  const [marketLoading, setMarketLoading] = useState(loading);
  const [countryLineLoading, setCountryLineLoading] = useState(true);
  const [marketLineLoading, setMarketLineLoading] = useState(true);
  const [trendCouputeData, setTrendCouputeData] = useState([]);
  const [trendError, setTrendError] = useState(false);
  const [marketError, setMarketError] = useState(false);
  const [marketChartNoData, setMarketChartNoData] = useState(false);
  const [marketChartType, setMarketChartType] = useState<string>('line');
  const [marketFixedTableData, setMarketFixedTableData] = useState<any[]>([]);
  const [trendComputeType, setTrendComputeType] = useState('');
  const [trendCount, setTrendCount] = useState('');
  const segementList = pageCfg?.tableMetricList; // getPUCDigitalPyhsicalList(pageId, tabType, entityType);
  const [metricSegVal, setMetricSegVal] = useState(segementList?.[0]?.value);
  const [sumAvgMaxList, setSumAvgMaxList] = useState([]);
  const [steamReviews, setSteamReviews] = useState({});

  // 折线图指标筛选：在 PC PCU stats / countries 页启用，最多选 2 个，控制折线图仅展示选中的指标
  const showLineMetricFilter = (isStatsPage || isCountriesPage) && pageId === DETAIL_PAGEID.pcu && entityType === 'pc';
  const defaultLineMetricSelected = useMemo(() => {
    if (!showLineMetricFilter) return [];
    const preferred = ['source_steam__pcu', 'source_steam__acu'];
    const valid = preferred.filter((v) =>
      (segementList || []).some((item: any) => item?.value === v),
    );
    if (valid.length > 0) return valid;
    return (segementList || []).slice(0, 2).map((item: any) => item?.value);
  }, [showLineMetricFilter, segementList]);
  const [lineMetricSelected, setLineMetricSelected] = useState<string[]>(
    defaultLineMetricSelected,
  );
  useEffect(() => {
    if (showLineMetricFilter && lineMetricSelected?.length === 0 && defaultLineMetricSelected?.length > 0) {
      setLineMetricSelected(defaultLineMetricSelected);
    }
  }, [showLineMetricFilter, defaultLineMetricSelected]);

  // 用户是否手动修改了国家区域
  const userManuallyChangedRegionRef = useRef(false);

  // 获取可视化下载配置hooks
  const { chartDownloadConfig, setSumList, setTrendsChartDownList, showDropdownBtnListCur } =
    useChartDownloadHooks({
      locale,
      metricValue: metricSegVal,
      entityType,
      activeSegment,
    });

  const {
    setEarliestDay,
    earliestPeriod,
    setEarliestPeriod,
    formattedEarliestDay,
    getEarliestDayAndEarliesPeriod,
    updateEarliestDateData,
    baseReleaseTimeValue,
    baseReleaseTimeData,
  } = useEarliestTime({
    entityType,
    basicInfo,
    appIds,
    dateType: fetchParams.date_type,
    topchartsState,
  });

  // PC 端 PCU 页：通过 /common/metric_date 获取最早数据日期
  // 复用父组件 useGamesDetailsModel 已经拉到的 combineGameIdList，从中取出 PC 单端 game_id，
  // 再用 PC 上 PCU/ACU/Followers/Reviews 等所有数据源指标去查 min_date，取全局最早
  // 接口异常或无数据时不覆盖原有 formattedEarliestDay，保留原有兜底显示逻辑
  const [apiEarliestDay, setApiEarliestDay] = useState<string>('');
  const isPcPcuPage = entityType === 'pc' && pageId === DETAIL_PAGEID.pcu;
  const pcSingleEndId = useMemo(() => {
    if (!Array.isArray(combineGameIdList)) return '';
    const pcEntry = combineGameIdList.find(
      (item: any) =>
        item?.entity_type === 'combine' && item?.id && item?.id !== 'None' && item?.id !== '',
    );
    return pcEntry?.id || '';
  }, [combineGameIdList]);

  useEffect(() => {
    if (!isPcPcuPage) return;
    if (!pcSingleEndId) {
      setApiEarliestDay('');
      return;
    }
    // 折线图选中的指标决定最早日期：每次切换指标都按当前选中重新请求
    if (!lineMetricSelected || lineMetricSelected.length === 0) {
      setApiEarliestDay('');
      return;
    }

    let cancelled = false;
    const fetchEarliest = async () => {
      try {
        const metricDateRes: any = await fetchMetricsDateRanges({
          game_ids: [pcSingleEndId],
          markets: [],
          metrics: lineMetricSelected,
          granularities: ['daily', 'weekly', 'monthly'],
          group_by: [],
          entity_types: ['pc'],
        } as any);
        if (cancelled) return;
        const list = Array.isArray(metricDateRes?.data) ? metricDateRes.data : [];
        const validDates: string[] = list
          .map((item: any) => item?.min_date)
          .filter(
            (d: any) => typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d),
          );
        if (validDates.length === 0) {
          setApiEarliestDay('');
          return;
        }
        // YYYY-MM-DD 字符串排序与日期升序一致，取首个即最早
        const earliest = validDates.slice().sort()[0];
        setApiEarliestDay(earliest || '');
      } catch (err) {
        console.warn('fetchMetricsDateRanges error', err);
        if (!cancelled) setApiEarliestDay('');
      }
    };
    fetchEarliest();
    return () => {
      cancelled = true;
    };
  }, [isPcPcuPage, pcSingleEndId, lineMetricSelected]);

  // 新接口拿到则优先使用，否则回落到原 useEarliestTime 计算结果
  const displayedEarliestDay = apiEarliestDay || formattedEarliestDay;

  useEffect(() => {
    // 是否请求完basic接口
    if (isBasicLoading || filterLoading) {
      // 选择单appid时要重新loading
      setLoading(true);
    } else {
      let newFetchParams = {
        ...fetchParams,
      };
      const { filterValue, filterParams } = getDbiFilterParams({
        // urlFilter: any,
        filterSaveData: filterData?.apiValue,
        filterExtend: filerExtendWithoutRegion,
        specialParams: filterCfg?.specialParams,
        isOperate: isOperateDetail,
        filterName,
        filterKeyList: filterCfg?.filterKeyList ?? Object.keys(DEFAULT_FORM_VALUE),
      });

      if (isOperateDetail) {
        // 如果目前是继承模式，就设置继承值为过滤后的筛选器值
        setDetailFilterExtend({
          ...filterValue,
          // 用户手动修改国家地区筛选器，值才被其他页面继承
          ...(userManuallyChangedRegionRef.current
            ? { region: filterValue?.region }
            : { region: undefined }),
        });
      }
      setFilterVale(filterValue);
      newFetchParams = {
        ...newFetchParams,
        ...filterCfg?.handleFilterToApiParams(filterParams),
      };

      getPageData(newFetchParams);

      updateEarliestDateData({
        dataSources: [newFetchParams.source],
        metrics: [metricKey],
        regionType: fetchParams.region_type,
        regions: fetchParams.regions,
        dateType: fetchParams.date_type,
        segment: fetchParams.segment || '',
      });
    }
  }, [isBasicLoading, pageId, filterLoading, subSegment]);

  const getPageData = (newFetchParams: any) => {
    if (isStatsPage) {
      getStatsData(newFetchParams);
    } else if (isCountriesPage) {
      getCountry(newFetchParams);
    } else {
      console.error(`tabType=${tabType} is not stats||countries!`);
    }
  };

  const getStatsData = async (params = fetchParams) => {
    const newFetchParams = { ...fetchParams, ...params };
    setFetchParams(newFetchParams);
    try {
      /** 接口速率优化：
       * 第一次时间为空时先请求trend获取时间后再请求channel
       * 如果时间不为空，则可以同时请求2个接口
       */
      const { start_date, end_date, sum_avg = [] } = await getTrends(newFetchParams);
      // 如果是需要提供可视化下载的metirc，需要调用此hooks方法，提供对应config数据
      if (showDropdownBtnList && sum_avg?.length > 0) {
        setSumList(sum_avg);
      }

      if (start_date && end_date) {
        newFetchParams.start_date = start_date;
        newFetchParams.end_date = end_date;
      } else {
        const [defautStart, defautEnd] = getDefaultTime(newFetchParams.date_type, isTwoMonths);
        newFetchParams.start_date = defautStart;
        newFetchParams.end_date = defautEnd;
      }
      setFetchParams(newFetchParams);
    } catch (err) {
      console.error(err);
      setTrendLoading(false);
    }
  };

  const getTrends = async (params: any) => {
    setTrendLoading(true);
    setLoading(true);
    const newFetchParams = { ...fetchParams, ...params };
    setFetchParams(newFetchParams);
    setTrendLineList([]);
    setTrendTableList([]);
    setDeviceLineData([]);
    // 添加游戏ID校验规则
    if (COMBINEID_REG.test(newFetchParams?.unified_id)) {
      try {
        const trendRes = await getTrendsFun?.(newFetchParams);

        const countData = trendRes?.data?.total || [];
        setTrendCouputeData(countData?.length > 0 ? countData : []);

        const startDate = trendRes?.req?.start_date;
        const endDate = trendRes?.req?.end_date;
        const reqApi = {
          ...newFetchParams,
          start_date: startDate,
          end_date: endDate,
        };
        setFetchParams({ ...reqApi });
        setTrendLineList(trendRes?.data?.trends || []);
        setTrendsChartDownList(trendRes?.data?.trends || []);
        setTrendTableList(trendRes?.data?.trends || []);
        setDeviceLineData(trendRes?.data?.device_trends || []);
        if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
          setPieData(trendRes?.data?.total || []);
          setSumAvgMaxList(trendRes?.data?.sum_avg || []);
        } else {
          setPieData([]);
        }
        setDevicePieData(trendRes?.data?.device_pie || []);
        setTrendLoading(false);
        setLoading(false);
        setTrendError(false);
        return {
          start_date: startDate,
          end_date: endDate,
          sum_avg: trendRes?.data?.sum_avg || [],
        };
      } catch (err) {
        setTrendLineList([]);
        setTrendTableList([]);
        setDevicePieData([]);
        setSumAvgMaxList([]);
        setPieData([]);
        setTrendLoading(false);
        setLoading(false);
        setTrendError(true);
        return {
          start_date: '',
          end_date: '',
        };
      }
    } else {
      setTrendLineList([]);
      setTrendTableList([]);
      setDevicePieData([]);
      setSumAvgMaxList([]);
      setPieData([]);
      setTrendLoading(false);
      setLoading(false);
      setTrendError(true);
      return {
        start_date: '',
        end_date: '',
      };
    }
  };

  const buildGsdCountriesRequestParams = (params: any) => {
    if (pageId !== DETAIL_PAGEID.gsd) {
      return params;
    }

    return buildCountriesChartRequestParams(params);
  };

  const getTop5DataList = (
    topListCur = topListTmpCur,
    metricCur = metricSegVal,
  ) => {
    const listDatas: any = Array.isArray(topListCur) ? topListCur : topListCur?.list || [];
    const metricList = listDatas.filter((item: any) => {
      return item?.metrics?.find((metricItem: any) => metricItem.metric == metricCur);
    });
    const displayList = buildCountriesChartDisplayList(metricList);
    setMarketChartTop5List(displayList);
    setMarketPieOtherList([]);
    return displayList;
  };

  const getTabelTopList = (tableList: any[], metric: string) => {
    const sortData = sortTableByMetric({
      tableData: tableList,
      sortParams: {
        ratioType: 0,
        sortVal: 'desc',
        sortMetric: metric,
      },
      metricProperty: 'metric',
      growthProperty: 'dod',
    });
    const listTemp = getTopList(sortData) || [];
    setTopListTmpCur(listTemp);
    return listTemp;
  };

  const getTop5DataListHandle = (tableList: any[], metric: string) => {
    const topListTmp = getTabelTopList(tableList, metric);
    if (pageId === 'gsd') {
      getTop5DataList(topListTmp, metric);
    }
  };

  const getCountry = async (params: any, selectedMetric = metricSegVal) => {
    const newFetchParams = {
      ...fetchParams,
      ...params,
    };
    newFetchParams.app_ids = appIds;
    setFetchParams(newFetchParams);
    setLoading(true);
    setMarketLoading(true);
    setMarketLineList([]);
    setMarketTableList([]);
    const marketType = getMaketsType(newFetchParams.regions, newFetchParams.regions);
    // 添加游戏ID校验规则
    if (COMBINEID_REG.test(newFetchParams?.unified_id)) {
      try {
        const countryRes = await getMarketTableFun?.(
          buildGsdCountriesRequestParams(newFetchParams),
        );
        let startDate = '';
        let endDate = '';

        if (countryRes?.code === 0 && !!countryRes?.data) {
          const tableList = countryRes?.data?.list || [];
          const selectedMetricTableList = filterCountriesByMetric(tableList, selectedMetric);
          setMarketChartNoData(
            pageId === DETAIL_PAGEID.gsd && selectedMetricTableList.length === 0,
          );
          const topListTmp = getTabelTopList(tableList, selectedMetric);
          if (pageId === 'gsd') {
            getTop5DataList(topListTmp, selectedMetric);
          }
          // fix 没数据时不给firstFixedData赋值，不然会多出global等
          const firstFixedData = getFixedTableData(marketType, topListTmp);
          setMarketFixedTableData(firstFixedData);
          if (pageId === DETAIL_PAGEID.gsd) {
            setMarketTableList(buildCountriesTableDisplayList(topListTmp.list));
          } else {
            setMarketTableList(topListTmp.list);
          }
          const allCountryList = countryRes?.data?.device_list || [];
          setCountryDeviceList(allCountryList);

          // 在countries并且pageId ==== 'gsd'不需要调用此逻辑，添加柱状Device堆叠数据
          if (!(isCountriesPage && pageId === 'gsd')) {
            const tempList = topListTmp?.list || [];
            const arrTemp: any = [];
            tempList?.forEach((item: any) => {
              allCountryList?.forEach((subItem: any) => {
                if (item.market == subItem.market) {
                  arrTemp.push(subItem);
                }
              });
            });
            // 添加柱状Device堆叠数据
            setDeviceBarData(arrTemp);
          }

          startDate = countryRes?.req?.start_date;
          endDate = countryRes?.req?.end_date;
          if (startDate && endDate) {
            newFetchParams.start_date = startDate;
            newFetchParams.end_date = endDate;
          } else {
            const [defautStart, defautEnd] = getDefaultTime(newFetchParams.date_type, isTwoMonths);
            newFetchParams.start_date = defautStart;
            newFetchParams.end_date = defautEnd;
          }
          setFetchParams(newFetchParams);

          if (marketChartTypeRef.current == 'line' || marketChartTypeRef.current == 'stackedLine') {
            const countryParmas = buildGsdCountriesRequestParams(newFetchParams);
            getCountryTrends(countryParmas);
          }
        } else {
          setMarketChartNoData(false);
          setMarketLineList([]);
          setMarketTableList([]);
        }
        setMarketError(false);
      } catch (err) {
        setMarketChartNoData(false);
        console.error(err);
        setMarketLineList([]);
        setMarketTableList([]);
        setMarketError(true);
      }
    } else {
      setMarketChartNoData(false);
      setMarketLineList([]);
      setMarketTableList([]);
    }
    setMarketLoading(false);
    setLoading(false);
  };

  // 添加topList的传入，防止异步
  const getCountryTrends = async (params: any) => {
    setCountryLineLoading(true);
    setMarketLineLoading(true);
    try {
      // 首次请求后就把折线图数据存起来， 点折线图图片就直接取； 只有改变筛选器时才重新请求
      const res = await getMarketTrendsFun?.(params);
      const lineDataRes = res?.data?.trends || [];
      setMarketLineList(lineDataRes);
    } catch (err) {
      setMarketLineList([]);
    } finally {
      setCountryLineLoading(false);
      setMarketLineLoading(false);
    }
  };

  const handleConfirm = (
    value: any,
    ifChangeDigReveSegment = true,
    metricSegValTemp = metricSegVal,
    unitsRedioTemp = unitsRedio,
  ) => {
    let newFetchParams = { ...fetchParams, ...value };
    if (value.segment == 'All' && unitsRedioTemp == 'Full Game' && metricSegValTemp === 'units') {
      newFetchParams = { ...newFetchParams, segment: unitsRedio };
    }
    if (ifChangeDigReveSegment) {
      setDigReveSegment(value.segment);
    }
    // 获取页面接口
    getPageData(newFetchParams);
    // 如果不是操作时间筛选器则请求最早时间接口，否则不请求接口
    if (
      value?.metrics !== fetchParams?.metrics ||
      value?.region_type !== fetchParams?.region_type ||
      value?.regions !== fetchParams?.regions
    ) {
      updateEarliestDateData({
        dataSources: [newFetchParams.source],
        metrics: [metricKey],
        regionType: newFetchParams.region_type,
        regions: newFetchParams.regions,
        dateType: newFetchParams.date_type,
        segment: newFetchParams.segment || '',
      });
    } else {
      /** 时间筛选器类型切换时， */
      const { earliestDay, earliestPeriod } = getEarliestDayAndEarliesPeriod(
        newFetchParams.date_type,
        newFetchParams.metrics,
      );
      setEarliestDay(earliestDay);
      setEarliestPeriod(earliestPeriod);
    }
  };

  const handleChangeExtra = (key: string) => {
    if (key === 'region') {
      userManuallyChangedRegionRef.current = true;
    }
  };

  const changeMarketChartType = (value: string) => {
    setMarketChartType(value);
    marketChartTypeRef.current = value;
    if (value === 'line' || value === 'stackedLine') {
      const countryParmas = buildGsdCountriesRequestParams(fetchParams);
      getCountryTrends(countryParmas);
    }
  };

  const getDownloadFetchParams = () => {
    let paramsTemp = fetchParams;
    if (mainSegment == 'pcu') {
      paramsTemp = {
        ...paramsTemp,
        region_type: 'region',
        regionType: 'region',
        regions: ['global'],
      } as any;
    }

    if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE && mainSegment === 'pcu') {
      paramsTemp = {
        ...paramsTemp,
        device: ['PC'],
      };
    }

    return {
      ...paramsTemp,
      unified_id: gameId,
      unified_ids: [gameId],
      currentMetric: ['revenue'].includes(mainSegment) ? subSegment : mainSegment,
      subSegment,
      isCountriesPage,
      metricSegVal,
    };
  };

  const pageSortAttr = getDefaultPageSortAttr(
    isStatsPage,
    fetchParams?.sort_type,
    fetchParams?.sort_field,
  );

  const getCardStatus = () => {
    if (isCountriesPage) {
      return {
        isLoading: loading || marketLoading,
        isError: marketError,
        isNoData: !marketTableList?.length && !marketFixedTableData?.length,
      };
    }
    return {
      isLoading: loading || trendLoading,
      isError: trendError,
      isNoData: !trendTableList?.length,
    };
  };

  const segementTitle = useMemo(() => {
    const foundText = segementList?.find((item: any) => item?.value == metricSegVal)?.text;
    if (foundText) {
      return formatMessage({ id: foundText });
    }
    return '';
  }, [locale, metricSegVal, segementList]);

  const trendTitle = useMemo(
    () => getPUCDigitalPyhsicalListTrendTitle(subSegment, pageId),
    [pageId, subSegment, locale],
  );

  useEffect(() => {
    const activeItem: any = trendCouputeData.find((item: any) => item.metric === metricSegVal);
    const steamreviewsData: any = trendCouputeData.find(
      (item: any) => item.metric === 'alinea__steamreviews',
    );
    setTrendComputeType(getComputeType(activeItem?.opt));
    setTrendCount(valueFormat(activeItem?.value, false, 0).toString());
    setSteamReviews(valueFormat(steamreviewsData?.value, false, 0));
  }, [trendCouputeData, metricSegVal]);

  const subTitle = useMemo(() => {
    let title = '';
    if (entityType !== PC_CONSOLE_COMBINE_ENTITY_TYPE && isStatsPage && !loading) {
      const sumavgTitle = `${trendComputeType} ${segementTitle} : ${trendCount}`;
      title = sumavgTitle;
      if (pageId === DETAIL_PAGEID.pcu) {
        title = `${sumavgTitle}, ${formatMessage({
          id: 'dbi_total_reviews',
        })}: ${steamReviews}`;
      }
    }
    return title;
  }, [loading, trendComputeType, segementTitle, trendCount, steamReviews, locale]);

  const getNodataMessage = () => {
    // 只调整PCU/mscience跟vgi
    if (isFortyDay && fetchParams?.date_type === 'monthly' && isStatsPage) {
      return formatMessage({ id: 'dbi_info_fortyday_nodatamsg' });
    }
    if (digReveSegment === 'Full Game') {
      return formatMessage({ id: 'dbi_info_fullgame_nodata' });
    }
    if (metricSegVal === 'units' && unitsRedio === 'Full Game') {
      return formatMessage({ id: 'dbi_info_unitsfullgame_nodata' });
    }
    return formatMessage({ id: 'common_nodata' });
  };

  const ifUseMarketLineLoading = useMemo(() => {
    let ifUseTemp = false;
    switch (mainSegment) {
      case 'digitalRevenue':
      case 'gsd':
        ifUseTemp = true;
        break;
      default:
        ifUseTemp = false;
    }
    if (
      ifUseTemp &&
      isCountriesPage &&
      (marketChartType == 'line' || marketChartType == 'stackedLine')
    ) {
      ifUseTemp = true;
    } else {
      ifUseTemp = false;
    }
    return ifUseTemp;
  }, [mainSegment, isCountriesPage, marketChartType]);
  let showCountriesChartItemNum: number | undefined;
  if (isCountriesPage && pageId === DETAIL_PAGEID.gsd) {
    showCountriesChartItemNum = Number.MAX_SAFE_INTEGER;
  }

  const visualisTitleNowCur = useMemo(() => {
    // if(segementList?.length){ //下面的判断可以用list列表长度来判断不？
    if (
      pageId === DETAIL_PAGEID.digitalRevenue ||
      pageId === 'gsd' ||
      pageId === DETAIL_PAGEID.physicalRevenue
    ) {
      return segementTitle;
    }
    return pcuSEGMENT[metricKey == 'physicalRevenue' ? 'revenue' : metricKey];
  }, [pageId, segementTitle, pcuSEGMENT, metricKey]);

  const barDataCur = useMemo(() => {
    if (isCountriesPage) {
      if (pageId == DETAIL_PAGEID.pcu) {
        return marketFixedTableData;
      }
      if (pageId === 'gsd') {
        return marketChartTop5List;
      }
      return marketTableList;
    }
    return [];
  }, [
    pageId,
    marketTableList,
    marketChartTop5List,
    isCountriesPage,
    marketFixedTableData,
    metricSegVal,
    marketChartType,
  ]);

  const marketLineListCur = useMemo(() => {
    if (isCountriesPage) {
      if (pageId === 'gsd') {
        const chartMarkets = marketChartTop5List?.map((item: any) => item.market);
        const listTemp: any = [];
        if (chartMarkets?.length > 0) {
          for (const i in chartMarkets) {
            const metricObj = marketLineList?.find((item: any) => item.market == chartMarkets[i]);
            if (metricObj) {
              listTemp.push(metricObj);
            }
          }
        }
        return listTemp;
      }
      return marketLineList;
    }
    return trendLineList;
  }, [pageId, marketLineList, trendLineList, isCountriesPage, marketChartTop5List]);

  // 包装 pageCfg.lineSeriesFormatter：
  // 1) 仅渲染下拉框选中的指标对应折线
  // 2) 将折线 name 中的 i18n key（例如 dbi_metric_gamalytic_steam_followers）翻译为对应中英文文案
  // 3) 在 legend 名前拼接数据源名（如 "Gamalytic Steam PCU"），区分 Alinea / Gamalytic / VGI 同名指标
  const effectivePageCfg = useMemo(() => {
    const originalFormatter = pageCfg?.lineSeriesFormatter;
    if (typeof originalFormatter !== 'function') return pageCfg;
    // 仅当 name 看起来像 i18n key（dbi_ 前缀）时才走 formatMessage，避免误翻译已经是文案的情况
    const localizeName = (name: any) => {
      if (typeof name !== 'string' || !name) return name;
      if (!/^dbi_/.test(name)) return name;
      return formatMessage({ id: name, defaultMessage: name });
    };
    const LINE_LEGEND_SOURCE_NAME: Record<string, string> = {
      source_steam: 'Steam',
      steamcharts: 'Steam',
      vginsights: 'VGI',
      gamalytic: 'Gamalytic',
      alinea: 'Alinea Analytics',
    };
    const prependDataSourceName = (name: any, dataSource: any) => {
      if (typeof name !== 'string' || !dataSource) return name;
      const sourceName =
        LINE_LEGEND_SOURCE_NAME[dataSource] || (DATASOURCE_NAME as any)?.[dataSource];
      if (typeof sourceName !== 'string' || !sourceName) return name;
      if (sourceName === 'Steam') {
        return `${sourceName} ${name.replace(/^Steam\s+/i, '')}`;
      }
      return `${sourceName} ${name}`;
    };
    return {
      ...pageCfg,
      lineSeriesFormatter: (params: any) => {
        const result = originalFormatter(params);
        if (!result || !Array.isArray(result?.source)) return result;
        const sourceWithLocalizedName = result.source.map((item: any) => ({
          ...item,
          name: prependDataSourceName(localizeName(item?.name), item?.dataSource),
        }));
        const filteredSource = showLineMetricFilter
          ? sourceWithLocalizedName.filter((item: any) =>
            lineMetricSelected?.includes(item?.id),
          )
          : sourceWithLocalizedName;
        return {
          ...result,
          source: filteredSource,
        };
      },
    };
  }, [pageCfg, showLineMetricFilter, lineMetricSelected, formatMessage, locale]);

  const deviceBarDataCur = useMemo(() => {
    if (isCountriesPage) {
      if (pageId === 'gsd') {
        const arrTemp: any = [];
        marketChartTop5List?.forEach((item: any) => {
          countryDeviceList?.forEach((subItem: any) => {
            if (item.market == subItem.market) {
              arrTemp.push(subItem);
            }
          });
        });
        return arrTemp;
      }
      return deviceBarData;
    }
    return deviceBarData;
  }, [pageId, deviceBarData, isCountriesPage, marketChartTop5List, countryDeviceList]);

  return (
    <>
      <div className="dbi-statsfilter-warp">
        <div className="statsfilter-warp-left">
          {showLineMetricFilter && (
            <div style={{ marginRight: 10 }}>
              <VisuailsMetricSelector
                disabled={
                  isCountriesPage
                    ? loading || countryLineLoading
                    : loading || trendLoading
                }
                options={segementList}
                visuailsMetricValues={lineMetricSelected}
                setVisuailsMetricValues={setLineMetricSelected}
              />
            </div>
          )}
          {filterLeftComp}
          <Filter
            ref={filterInstance}
            timeFilterValues={{
              type: fetchParams.date_type,
              value: [fetchParams.start_date, fetchParams.end_date],
            }}
            filterConfirm={handleConfirm}
            onChangeExtra={handleChangeExtra}
            filterReset={() => {}}
            sinceReleaseTime={baseReleaseTimeValue}
            earliestDataTime={earliestPeriod}
            filterValue={filterValue}
            setFilterVale={setFilterVale}
            filterCfg={filterCfg}
            defaultValue={DEFAULT_FORM_VALUE}
          />
          {filterIcon ? filterIcon : null}
        </div>
        <div className="dbi-statsfilter-warp-right">
          <ExportTable
            entityType={entityType}
            tableParams={getDownloadFetchParams()}
            businessType={
              pageId === 'pcu'
                ? `${entityType}-stats-countries-pcu`
                : `${entityType}-stats-countries`
            }
            isDisableDownload={loading}
            isShowMaxDownloadRowsTips={false}
            downloadModalSize={downloadModalSize}
            isDisableDataAmount={true}
            newStyleFileName={`${basicInfo?.name}${
              isStatsPage ? '_Stats' : isCountriesPage ? '_Countries' : ''
            }`}
            pageId={
              entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE
                ? TopchartPageId.PCConsoleMetricsTable
                : undefined
            }
            gsdDevicesFlatten={gsdDevicesFlatten}
            gsdSegments={gsdSegments}
            showDropdownBtnList={
              isStatsPage && (trendChartType === 'line' || trendChartType === 'stackedLine')
                ? showDropdownBtnListCur
                : false
            }
            chartDownloadConfig={chartDownloadConfig}
            tabType={tabType}
            downloadLogConfigKey={pcconsoleStats?.[`${entityType}_${tabType}_${pageId}`]}
          />
        </div>
      </div>
      <CombineContent
        subTitle={subTitle}
        cardTitle={
          pageCfg?.cardTitle
            ? formatMessage({ id: pageCfg?.cardTitle })
            : isStatsPage
              ? `${formatMessage({ id: trendTitle })}${locale === 'zh-CN' ? '' : ' '}${formatMessage({
                id: `dbi_detail_trend`,
              })}`
              : ''
        }
        pageId={pageId}
        entityType={entityType}
        isCountriesPage={isCountriesPage}
        fixedTableData={marketFixedTableData}
        tableData={isCountriesPage ? marketTableList : trendTableList}
        sumAvgMaxList={sumAvgMaxList}
        lineData={marketLineListCur}
        barData={barDataCur}
        pieData={isCountriesPage ? marketTableList : pieData}
        stackBarData={deviceBarDataCur}
        stackLineData={deviceLineData}
        stackPieData={devicePieData}
        chartType={isCountriesPage ? marketChartType : trendChartType}
        setChartType={isCountriesPage ? changeMarketChartType : setTrendChartType}
        metricSegVal={metricSegVal}
        setMetricSegVal={(value: string) => {
          setMetricSegVal(value);
          const newFetchParams = { ...fetchParams, sort_field: value };
          if (
            isCountriesPage &&
            pageId === DETAIL_PAGEID.gsd
          ) {
            getCountry(newFetchParams, value);
            return;
          }
          if (isStatsPage && pageId === 'digitalRevenue') {
            // 只有Digitalunits切换有个ratio要选，所以要ifelse重新调用接口，其他都已经有返回
            if (value == 'units' && digReveSegment == 'All' && digReveSegment != unitsRedio) {
              handleConfirm({ segment: unitsRedio }, false);
            } else if (fetchParams.segment != digReveSegment) {
              handleConfirm({ segment: digReveSegment }, false, value);
            }
          }
        }}
        cardStatus={getCardStatus()}
        pageCfg={effectivePageCfg}
        earliestDay={displayedEarliestDay}
        baseReleaseTime={baseReleaseTimeData}
        firstWeekReleaseTime={baseReleaseTimeValue}
        earliestPeriod={earliestPeriod}
        defaultByDeviceVal={defaultByDeviceVal}
        dateType={fetchParams.date_type}
        startDate={fetchParams.start_date}
        endDate={fetchParams.end_date}
        pageSortAttr={pageSortAttr}
        chartLoading={isCountriesPage ? countryLineLoading : trendLoading}
        chartIsNoData={isCountriesPage ? marketChartNoData : undefined}
        setChartLoading={isCountriesPage ? () => {} : setTrendLoading}
        marketLineLoading={marketLineLoading}
        ifUseMarketLineLoading={ifUseMarketLineLoading}
        visualisMetric={activeSegment == 'acu' ? 'acu' : metricSegVal}
        visualisTitleNow={visualisTitleNowCur}
        gameName={basicInfo?.name}
        gameCover={basicInfo?.cover}
        changeDeviceBtn={() => {}}
        regionsCountries={regionsCountries || []}
        showRadio={isStatsPage && metricSegVal === 'units' && digReveSegment == 'All'}
        radioValue={unitsRedio}
        setRadioValue={(value: string) => {
          setUnitsRedio(value);
          handleConfirm({ segment: value }, false, metricSegVal, value);
        }}
        legendSelected={
          ['pcu', 'acu']?.includes(mainSegment)
            ? { 'Steam Reviews': false }
            : {}
        }
        noDataMessage={getNodataMessage()}
        mainSegment={mainSegment}
        trendTitle={trendTitle}
        getTop5DataList={getTop5DataListHandle}
        topListTmpCur={topListTmpCur}
        calOtherList={marketPieOtherList}
        lineSourceName={lineSourceName}
        ifLineChartLegendOn={showDropdownBtnListCur}
        showChartsItemNum={showCountriesChartItemNum}
        onMetricExplanationClick={(key, payload) => {
          if (entityType !== PC_CONSOLE_COMBINE_ENTITY_TYPE) return;
          if (metricKey !== DETAIL_PAGEID.digitalRevenue) return;
          handleMetricExplanationTipsClick(key, payload, {
            filterValue: {},
            // @ts-ignore
            onClickSetRegionUSOnly: (filterValuePayload) => {
              const formValueTmp = filterInstance.current?.getFormValue();
              filterInstance.current?.setFormValue({
                ...formValueTmp,
                [filterKeyMap.REGION]: {
                  ...formValueTmp?.[filterKeyMap.REGION],
                  ...filterValuePayload?.[filterKeyMap.REGION],
                },
              });
              // @ts-ignore
              handleConfirm({
                ...fetchParams,
                region_type: 'market',
                regions: ['us'],
              });
            },
          });
        }}
      />
      <UserGuideCompetitor />
    </>
  );
}
